

















// TODO 弹出窗公告
import { Component, Vue } from 'vue-property-decorator'
import news from '@api/module/customer/news/NewsModule'
import NewsParam from '@api/module/customer/news/models/NewsParam'
import HomeModule from '@api/module/customer/basic-data/BasicDataModule'
import ConfigCenterModule from '@api/module/common/config-center/ConfigCenterModule'
const key = 'popNewsConfig'

class PopNewsConfig {
  id: string
  thisOneShowNoMore: boolean
}

let popNewsConfig = new PopNewsConfig()
try {
  popNewsConfig = JSON.parse(localStorage.getItem(key) || '')
} catch (e) {
  // todo
}
@Component
export default class extends Vue {
  showPop = false
  popNewsConfig: PopNewsConfig = popNewsConfig
  checked = false
  queryParam = new NewsParam()
  async getPopNews() {
    await news.getPopNews(this.queryParam)
    if (this.popNewsConfig.thisOneShowNoMore && this.popNewsConfig.id === this.popNewsNotice.newsNoticeDTO?.id) {
      // todo
    } else {
      this.showPop = this.popNewsNotice.hasPopNewsNoticeNow
    }
  }

  close() {
    if (this.checked) {
      this.changeShowNoMore()
    }
    this.showPop = false
  }

  changeShowNoMore() {
    this.showPop = false
    localStorage.setItem(
      'popNewsConfig',
      JSON.stringify({
        thisOneShowNoMore: true,
        id: this.popNewsNotice.newsNoticeDTO.id
      })
    )
  }
  get title() {
    return this.popNewsNotice?.newsNoticeDTO?.title || ''
  }

  get unitName() {
    return HomeModule.currentUnit?.name || ''
  }
  get content() {
    return this.popNewsNotice?.newsNoticeDTO?.content || `您好！欢迎访问${this.portalName}！`
  }
  get popNewsNotice() {
    return news.popNewsNoticeDTO
  }

  get portalName() {
    return HomeModule.currentUnit.portalName || '从业人员网络培训平台'
  }
  get currentUnit() {
    return HomeModule.currentUnit.id
  }

  async created() {
    this.queryParam.unitIdList = this.currentUnit ? [this.currentUnit] : []
    const subUnitId = ConfigCenterModule.getApplicationByName('applicationDiff.Basicdata.subUnitId')
    // console.log(window.location)
    await HomeModule.getCurrentUnitByDomain({
      domain: window.location.hostname,
      subUnitId: subUnitId
    })
    await this.getPopNews()
  }
}
